// [2026-10-30] 배포 직후 옛 번들이 지워진 chunk 를 요청하면 ChunkLoadError 가 난다 — 새로고침 한 번이면
//  새 index.html·main.js 를 받아 해결된다. 그런데 배포 중(파일 교체 사이)에는 새로고침해도 또 실패해
//  index.tsx · error-page.tsx 의 자동 새로고침이 끝없이 반복됐고, 매번 필수 공지 관문이
//  GET /user/notice 를 불러 "공지 무한 호출"로 보였다. 자동 새로고침은 일정 시간 안에 한 번만 한다.

const RELOAD_AT_KEY = 'chunkReloadAt';
/** 이 시간 안에 다시 실패하면 자동 새로고침하지 않는다(배포가 끝날 시간 여유) */
const RELOAD_COOLDOWN_MS = 30 * 1000;

/** ChunkLoadError(지연 로딩 실패) 판별 — Error · 문자열 · { message } 모두 */
export function isChunkLoadError(error: unknown): boolean {
  const message =
    typeof error === 'string'
      ? error
      : error && typeof error === 'object' && 'message' in error
        ? String((error as { message?: unknown }).message ?? '')
        : '';
  const name = error instanceof Error ? error.name : '';
  return (
    name === 'ChunkLoadError' ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('Failed to fetch dynamically imported module')
  );
}

/**
 * 자동 새로고침을 해도 되면 기록하고 true. 최근(쿨다운 안)에 이미 했으면 false —
 * 호출부는 새로고침 대신 "새로고침" 안내를 보여준다.
 */
export function claimChunkReload(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
    if (last && Date.now() - last < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(RELOAD_AT_KEY, String(Date.now()));
    return true;
  } catch {
    // 저장소를 못 쓰면 반복 여부를 알 수 없으니 자동 새로고침하지 않는다
    return false;
  }
}
